import BannerOverlay from "../components/BannerOverlay";
import { TeamContent } from "../components/pages/team/Team";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";

const Team = () => {
    return (
        <div className="m-0 p-0" style={{ background: "var(--brand-black)" }}>
            <Header />
            <BannerOverlay
                imageUrl="https://ik.imagekit.io/dnddecpho/dndream/D&D_Website_WebBanner_1920x500px_PC2_Ij3QlhYu_.jpg?updatedAt=1731826250613"
                title=""
            />
            <TeamContent />
            <Footer />
        </div>
    );
};

export default Team;
